import React from 'react';
import ReactDOM from 'react-dom/client';
import { MyIntlProvider } from 'my-intl';

import App from './App';
import { messages } from './data/messages';

import './index.scss';

const root = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <MyIntlProvider messages={messages}>
      <App />
    </MyIntlProvider>
  </React.StrictMode>
);
